<script lang="ts">
    import { getContext, onDestroy } from 'svelte'
    import { derived as sderived } from 'svelte/store'

    import { gettext as _ } from 'hydria/services/gettext'
    import { sanchor, spath } from 'hydria/svelte_helpers'

    import type { IDomain } from 'wdom/domain/interfaces'

    import type { DomainHandler } from './domain'

    const Domain = getContext('Domain') as DomainHandler
    const status = sderived(Domain.status, ($status) => $status)

    const unsubs: any[] = []
    onDestroy(() => {
        for (const unsub of unsubs) unsub.unsubscribe != null ? unsub.unsubscribe() : unsub()
    })

    let domain: IDomain = $derived($status == 'ready' ? Domain.domain : ({} as IDomain))

    let nameserverTaskRunning = $state(false)
    let nameservers: string[] = $derived($status == 'ready' ? domain.nameservers : [])
    unsubs.push(
        Domain.runningTasks.nameserver.subscribe((v) => {
            nameservers = domain.nameservers
            nameserverTaskRunning = v
        }),
    )
</script>

<style>
    .list-group {
        --bs-list-group-border-width: 0;
        --bs-list-group-border-radius: 0;
    }
</style>

<div class="card card-nameservers">
    <div class="card-title text-primary">{$_('Serveurs DNS')}</div>
    {#if domain.nameservers.length == 0}
        <div class="card-body">
            <p>{$_('No name server associated.')}</p>
        </div>
    {:else}
        <div class="card-body">
            <ul class="list-group">
                {#each nameservers as nameserver}
                    <li class="list-group-item">
                        <span>{nameserver}</span>
                    </li>
                {/each}
            </ul>
        </div>
    {/if}
    <div class="card-footer text-bg-light">
        <div class="d-flex">
            <span style="flex: 0 0 auto"
                >{#if Domain.zoneDomainRelation.zone_exists}<a use:sanchor href={spath(`/zone/${domain.idna}`)} class="btn btn-outline-secondary">Page de la zone</a>{/if}</span
            >
            <span style="flex: 1 0 0">
                {#if nameserverTaskRunning}
                    <div class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></div>
                    Update in progress
                {/if}
            </span>
            <span style="flex: 0 0 auto"><a use:sanchor href={spath(`/domain/${domain.idna}/nameservers`)} class="btn btn-primary">Éditer</a></span>
        </div>
    </div>
</div>
